import { NumericFormat } from 'react-number-format';
import { Link } from 'react-router-dom';
import Panel from '~/components/Panel';

interface Props {
  id: number;
  uniqueDonors?: number;
}

const UniqueDonorsBlock: React.FC<Props> = ({ id, uniqueDonors }) => {
  return (
    <>
      <Panel addClasses={`border-[#FEF2EA] bg-[#FEF2EA] flex-1`}>
        <h2 className='text-[16px]/[24px] font-medium uppercase text-[#131212]'>
          Unique Donors
        </h2>
        <div className='text-[38px]/[44px] font-bold'>
          <NumericFormat
            value={uniqueDonors ?? 0.0}
            thousandSeparator=','
            decimalScale={0}
            displayType='text'
          />{' '}
        </div>
        <div className='text-[16px]/[24px]'>
          <Link
            className='text-decoration-none text-[#F47D29]'
            to={`/campaigns/${id}/unique-donors`}
          >
            View All
          </Link>
        </div>
      </Panel>
    </>
  );
};

export default UniqueDonorsBlock;
